package team.platforma.dictionary_data.repository.ai_model

import io.ktor.client.HttpClient
import io.ktor.client.request.header
import io.ktor.client.request.request
import io.ktor.http.ContentType
import io.ktor.http.HttpMethod
import io.ktor.http.contentType
import kotlinx.coroutines.flow.Flow
import team.platforma.accountmanagerlib.getAccountManager
import team.platforma.dictionary_data.database.ai_chapter.AiChapterTable
import team.platforma.dictionary_data.database.ai_model.AiModelTable
import team.platforma.dictionary_data.network.AiResponseItem
import team.platforma.dictionarydata.table.AiChapter
import team.platforma.dictionarydata.table.AiModel
import team.platforma.wrapper.ResponseWrapper

class AiModelRepositoryImpl(
    private val client: HttpClient,
    private val aiModelTable: AiModelTable,
    private val aiChapterTable: AiChapterTable
) : AiModelRepository, ResponseWrapper() {

    private val mokList = listOf(
        AiModel(
            id = 1827613,
            name = "GigaChat",
            chapter = 1,
            description = "Cпособен общаться в режиме диалога, генерировать по запросу тексты и писать программный код.",
            cover = null
        ),
        AiModel(
            id = 1325526,
            name = "ChatGPT",
            chapter = 1,
            description = "Чат-бот с генеративным искусственным интеллектом, и способный поддерживать запросы на естественных языках.",
            cover = null
        ),
        AiModel(
            id = 2354363,
            name = "Midjourney",
            chapter = 2,
            description = "Подходит для разработки уникальных иллюстраций для книг, журналов, веб-сайтов и других медиаформатов.",
            cover = null
        ),
        AiModel(
            id = 2554234,
            name = "DALL·E 3",
            chapter = 2,
            description = "Способна генерировать изображения для создания инфографики, логотипов и дизайнов с текстовыми элементами.",
            cover = null
        ),
        AiModel(
            id = 26462123,
            name = "Kandinsky",
            chapter = 2,
            description = "Нейронная сеть для генерации высокохудожественных изображений в разных стилях.",
            cover = null
        ),
        AiModel(
            id = 33981615,
            name = "Видео с аватаром",
            chapter = 3,
            description = "Искусственный интеллект, который создает видео с говорящим аватаром в пару кликов.",
            cover = null
        ),
        AiModel(
            id = 37372523,
            name = "Нарезка видео на шортсы",
            chapter = 3,
            description = "Данная модель можете создавать короткие видео (шортсы) за несколько шагов.",
            cover = null
        ),
        AiModel(
            id = 48836264,
            name = "Озвучка текста",
            chapter = 4,
            description = "Набор технологий и инструментов, предназначенных для синтеза речи c интонацией, тоном и скоростью.",
            cover = null
        ),
        AiModel(
            id = 498766152,
            name = "Голос в текст",
            chapter = 4,
            description = "Нейросеть, ориентированная на распознавание речи на базе машинного обучения.",
            cover = null
        )
    )

    override suspend fun load() {
        val accessToken = getAccountManager().getUserAuthToken()
        wrapResponse<List<AiResponseItem>>(
            client.request("web-api/ai-model/list") {
                contentType(ContentType.Application.Json)
                header("Authorization", "Bearer $accessToken")
                method = HttpMethod.Get
            }
        ).onSuccess { list, code ->
            val aiList = list.map {
                AiModel(
                    id = it.ai_model_id,
                    name = it.name,
                    chapter = it.ai_model_group.ai_model_group_id,
                    description = it.description,
                    cover = null
                )
            }
            val chapterList = list.map {
                AiChapter(
                    id = it.ai_model_group.ai_model_group_id,
                    name = it.ai_model_group.title
                )
            }.toSet().toList() + AiChapter(
                id = -1,
                name = "Все"
            )

            aiModelTable.addAiList(aiList)
            aiChapterTable.addChapterList(chapterList)

        }
    }

    override fun observeAll(): Flow<List<AiModel>> = aiModelTable.observeAll()

    override fun observeByChapter(chapter: Long): Flow<List<AiModel>> =
        aiModelTable.observeByChapter(chapter)


}